<div class="container mx-auto px-4 pt-8 pb-12">
  <div class="mx-auto max-w-2xl text-center">
    <h1 class="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100 md:text-4xl">
      Summerry Daily Newsletter
    </h1>
    <p class="mt-4 text-lg text-gray-600 dark:text-gray-300">
      Subscribe and stay up to date with the most important AI news.
    </p>

    <div class="mt-8">
      <app-newsletter-subscribe [redirectToConfirmPage]="false" />
    </div>
  </div>
</div>
